import { ReactElement } from "react";
import { PaymentsModalType } from "entities/shared/subscriptionModel";
import { subscriptionStore } from "entities/Subscription";
import { useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";
import { Link } from "shared/ui/Button";
import { REQUEST_IT_QUOTE_CONTAINER_TRACKING_URL } from "shared/utils/url.utils";
// createRequestITQuoteUrl not in @qubictron/url — use plain quote URL.
// import { REQUEST_IT_QUOTE_AIR_TRACKING_URL_WEB_ACCESS } from "shared/utils/url.utils";
import styles from "./PaymentsModalBottomDescription.module.scss";

export const PaymentsModalBottomDescription: RFC = () => {
  const { t } = useTranslation();
  const activePaymentModal = useAppSelector(subscriptionStore.selectors.activePaymentModal);

  const paymentsModalBottomDescriptionMap: Record<PaymentsModalType, ReactElement | null> = {
    [PaymentsModalType.PAY]: null,
    [PaymentsModalType.FREE]: (
      <p className={styles.description}>
        {t("Any unused shipments will not be carried over to the next billing period or plan")}.{" "}
        {t("If our standard packages don't quite fit your needs, please submit your inquiry")}{" "}
        <Link target="_blank" href={REQUEST_IT_QUOTE_CONTAINER_TRACKING_URL} className={styles.descriptionLink}>
          {t("here")}
        </Link>{" "}
        {t("for a tailored solution")}.
      </p>
    ),
  };

  if (!activePaymentModal) return null;

  return paymentsModalBottomDescriptionMap[activePaymentModal];
};
